{
  "title": "Summon Elemental",
  "source": "Tasha's Cauldron of Everything",
  "levelAndSchool": "4th-level conjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (air, a pebble, ash, and water inside a gold-inlaid vial worth at least 400 gp)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You call forth an elemental spirit. It manifests in an unoccupied space that you can see within range. This corporeal form uses the Elemental Spirit stat block. When you cast the spell, choose an element: Air, Earth, Fire, or Water. The creature resembles a bipedal form wreathed in the chosen element, which determines certain traits in its stat block. The creature disappears when it drops to 0 hit points or when the spell ends.",
    "The creature is an ally to you and your companions. In combat, the creature shares your initiative count, but it takes its turn immediately after yours. It obeys your verbal commands (no action required by you). If you don’t issue any, it takes the Dodge action and uses its move to avoid danger.",
    "At Higher Levels. When you cast this spell using a spell slot of 5th level or higher, use the higher level wherever the spell’s level appears in the stat block.",
    "Elemental Spirit",
    "Medium elemental",
    "Armor Class: 11 + the level of the spell (natural armor)",
    "Hit Points: 50 + 10 for each spell level above 4th",
    "Speed: 40 ft.; burrow 40 ft. (Earth only); fly 40 ft. (hover) (Air only); swim 40 ft. (Water only)",
    "STR",
    "DEX",
    "CON",
    "INT",
    "WIS",
    "CHA",
    "18 (+4)",
    "15 (+2)",
    "17 (+3)",
    "4 (-3)",
    "10 (+0)",
    "16 (+3)",
    "Damage Resistances: acid (Water only); lightning and thunder (Air only); piercing and slashing (Earth only)",
    "Damage Immunities: poison; fire (Fire only)",
    "Condition Immunities: exhaustion, frightened, paralyzed, petrified, poisoned, unconscious",
    "Senses: darkvision 60 ft., passive Perception 10",
    "Languages: Primordial, understands the languages you speak",
    "Challenge: —",
    "Proficiency Bonus: equals your bonus",
    "Amorphous Form (Air, Fire, and Water Only). The elemental can move through a space as narrow as 1 inch wide without squeezing.",
    "Actions",
    "Multiattack. The elemental makes a number of attacks equal to half this spell’s level (rounded down).",
    "Slam. Melee Weapon Attack: your spell attack modifier to hit, reach 5 ft., one target. Hit: 1d10 + 4 + the spell’s level bludgeoning damage (Air, Earth, and Water only) or fire damage (Fire only)."
  ],
  "spellLists": ["druid", "ranger", "wizard"]
}
